import React from "react";

import Typewriter from "typewriter-effect";

import "./Type.css";

export const Type = () => {

  return (
    <>
      <div class="typewriter">
        <h3>A Full Stack Web Developer</h3>
      </div>
    </>
  );
};
